export default __webpack_public_path__ + "static/media/post-teacher.518108de.svg";